__turbopack_context__.v({
  "banner": "RegisterBanner-module-scss-module__zeNUVq__banner",
  "button": "RegisterBanner-module-scss-module__zeNUVq__button",
  "content": "RegisterBanner-module-scss-module__zeNUVq__content",
  "description": "RegisterBanner-module-scss-module__zeNUVq__description",
  "title": "RegisterBanner-module-scss-module__zeNUVq__title",
});
